module.exports = __webpack_public_path__ + "static/media/9DESA35.47d0897c.jpg";